import React, { FC } from "react";

import { TabBadgeProps } from "./TabBadge";

import style from "./styles/style.scss";

export interface TabProps {
    children?: JSX.Element;
    disabled?: boolean;
    title: string;
    titleBadge?: TabBadgeProps;
}

export const Tab: FC<TabProps> = (props: TabProps) => {
    return (
        <div className={style.tabWrap}>
            {props.children}
        </div>
    );
};
